import { routePath } from 'config/route-config';
const {
  VITE_BG_CLASIC_URL,
  VITE_BG_DOMAIN,
  VITE_NEP_CHANGE_TARIFF,
  VITE_BG_CLASSIC_CHANGE_TARIFF,
  VITE_PATH_PREFIX,
  VITE_LOGIN_URL
} = import.meta.env;

export const actionUrl = {
  bgHome: 'https://www.britishgas.co.uk',
  support: 'https://www.britishgas.co.uk/help-and-support',
  privacy: 'https://www.britishgas.co.uk/privacy-policy.html',
  bgSalesApp: `${VITE_BG_CLASIC_URL}?cid=bgEvolve_redirectBAU`,
  bgSalesTariffInformation: `${VITE_BG_CLASIC_URL}/tariff-information?cid=bgEvolve_redirectBAU`,
  bgLite:
    'https://signup.britishgaslite.co.uk/#/quote?cid_channel=evolvedirect',
  contact: 'https://www.britishgas.co.uk/energy/contact-us',
  nepChangeTariff: VITE_NEP_CHANGE_TARIFF,
  bgClassicChangeTariff: VITE_BG_CLASSIC_CHANGE_TARIFF,
  login: VITE_LOGIN_URL,
  directSales: `${VITE_PATH_PREFIX}${routePath.home}`,
  secondQuote: `${VITE_PATH_PREFIX}${routePath.secondQuote}`,
  moveIn: `${VITE_PATH_PREFIX}${routePath.moveIn}`,
  benefitPlus:
    'https://centricaplc.sharepoint.com/sites/benefits-plus/SitePages/overview-Energy-Allowance.aspx',
  smartMeter: 'https://www.britishgas.co.uk/smart-home/smart-meters.html',
  requestCallBack: 'https://forms.office.com/r/bMBbkmG2Nj',
  bgTermsAndConditions:
    'https://www.britishgas.co.uk/energy/gas-and-electricity/supply-terms-and-conditions.html',
  bgClassicHomeMoveUrl:
    'https://www.britishgas.co.uk/new-home/move-in/energy-quote',
  hiveTerms: 'https://www.hivehome.com/terms',
  bgHomeMove: `${VITE_BG_DOMAIN}/discover/home-move/`,
  crossSellOffer: `https://www.hivehome.com/shop/smart-heating/hive-thermostat-mini?cid=bg_switch_supplier`
};
